import { combineReducers } from "redux";
import { configureStore } from "@reduxjs/toolkit";
import activedFlowsReducer from "./activedFlows/reducers";
import flowsReducer from "./flows/reducers";
import usersReducer from "./users/reducers";
import authReducer from "./auth/reducers";
import activedTasksReducer from "./activedTasks/reducers";
import undoFlow from "./undoFlow/reducers";
import dashboardReducer from "./dashboard/reducer";

import undoable from "redux-undo";
import zaivuPersist from "./zaivuPersist/slice";
import filesLog from "./files/slice";
import flowTime from "./flowTime/slice";
import notificationReducer from "./notification/reducers";
import chatReducer from "./chat/reducers";
import finishedFlowsReducer from "./finishedFlows/reducers";

import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";
import { socketMiddleware } from "./notification/middleware";
import userStatsReducer from "./userStats/reducers";
import dndReducer from "./DnDSlice/slice.js";
import rdmReducer from "./rdms/reducers.js";

const persistConfig = {
  key: "root",
  storage,
};

const dndPersistConfig = {
  key: "dnd",
  storage,
};

const zaivuPersistState = persistReducer(persistConfig, zaivuPersist);
const dndPersistState = persistReducer(dndPersistConfig, dndReducer);

const rootReducer = combineReducers({
  flows: flowsReducer,
  activedFlows: activedFlowsReducer,
  users: usersReducer,
  auth: authReducer,
  activedTasks: activedTasksReducer,
  undoFlow: undoable(undoFlow),
  chat: chatReducer,
  fileLog: filesLog,
  flowTime: flowTime,
  notification: notificationReducer,
  finishedFlows: finishedFlowsReducer,
  userStats: userStatsReducer,
  dashboard: dashboardReducer,
  zaivuPersist: zaivuPersistState,
  dnd: dndPersistState,
  rdms: rdmReducer,
});

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).prepend(socketMiddleware),
});

const persistor = persistStore(store);

export { store, persistor };
